export const tagNamings = {
    "projects": "Projects",
    "achievements": "Achievements"
}
